module.exports = __webpack_public_path__ + "img/step5.dac4b0e9.png";